/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Pilot_Ready_KickerInputs */



/**
* | output |
* | --- |
* | "Ready to practise" |
*
* @param {Onboarding_Pilot_Ready_KickerInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const onboarding_pilot_ready_kicker = /** @type {((inputs?: Onboarding_Pilot_Ready_KickerInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Pilot_Ready_KickerInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Klaar om te oefenen")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Prêt à vous entraîner")
	return /** @type {LocalizedString} */ ("Ready to practise")
});